export default function createVehicleDescription(vehicle) {
  return `${vehicle.brand} ${vehicle.model} ${vehicle.version}`;
}
